module.exports = __webpack_public_path__ + "static/media/play-score.6c29752b.ogg";